import { Dialog } from 'vant'
const defaultRequestErrorHandle = err => {
  let error = (err.toString()).split(":")
  // alert(error[1])
  Dialog.confirm({
    title: '提示',
    messageAlign: 'left',
    showCancelButton: false,
    confirmButtonText:'我知道了',
    message: error[1],
  })
  return null;
}
export default defaultRequestErrorHandle